import React, { createContext, useContext, useState } from 'react';
import type { TourStep, TourState } from '../types/tour';

const defaultTourSteps: TourStep[] = [];

interface TourContextType {
  tour: TourState;
  startTour: () => void;
  endTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  goToStep: (step: number) => void;
  showTourPrompt: boolean;
  setShowTourPrompt: (show: boolean) => void;
  dismissTourPrompt: () => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export function TourProvider({ children }: { children: React.ReactNode }) {
  const [tour] = useState<TourState>({
    isActive: false,
    currentStep: 0,
    steps: defaultTourSteps,
    hasSeenTour: true
  });
  const [showTourPrompt] = useState(false);

  // Stub functions that do nothing
  const startTour = () => {};
  const endTour = () => {};
  const nextStep = () => {};
  const prevStep = () => {};
  const goToStep = () => {};
  const setShowTourPrompt = () => {};
  const dismissTourPrompt = () => {};

  return (
    <TourContext.Provider value={{ 
      tour, 
      startTour, 
      endTour, 
      nextStep, 
      prevStep, 
      goToStep,
      showTourPrompt,
      setShowTourPrompt,
      dismissTourPrompt
    }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}